// Variable interpolation for {{var_name}} tokens inside authored text.
//
// The authored content is HTML (TipTap StarterKit output) so we substitute
// at the string level before render, NOT after parsing. Substitutions are
// HTML-escaped to prevent injection from variable values.
const TOKEN_RE = /\{\{([\w_]+)\}\}/g;
const HTML_ESCAPE_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};
function escapeHtml(s) {
    return s.replace(/[&<>"']/g, (ch) => HTML_ESCAPE_MAP[ch] ?? ch);
}
/** A "chip" rendering of an unresolved variable token (preview / no-value mode). */
const TOKEN_CHIP_CLASS = 'inline-block bg-teal-100 text-teal-700 text-[0.75em] font-mono ' +
    'px-1.5 py-0.5 rounded mx-0.5 leading-none align-baseline';
export function interpolate(html, opts) {
    return html.replace(TOKEN_RE, (_match, name) => {
        const resolved = opts.mode === 'play'
            ? opts.values[name] ?? opts.examples?.[name]
            : opts.examples?.[name] ?? opts.values[name];
        if (resolved !== undefined && resolved !== null && resolved !== '') {
            return escapeHtml(resolved);
        }
        // Unresolved — render the token name as a chip so the recipient sees
        // exactly what was missing.
        return `<span class="${TOKEN_CHIP_CLASS}">${escapeHtml(name)}</span>`;
    });
}
/**
 * Strip {{var}} tokens for accessibility text where chip markup wouldn't help.
 * Used for `aria-label`s and the like.
 */
export function stripTokens(text) {
    return text.replace(TOKEN_RE, (_, name) => name);
}
